import * as React from 'react';
import { useIntl } from '@grandvisionhq/state';
import { CartSlider } from './CartSlider.js';
import { useCart } from '../../../context/Cart/context.js';

const CartSliderContainer = ({ children  })=>{
    const { getLabel  } = useIntl();
    const { cart  } = useCart();
    return /*#__PURE__*/ React.createElement(CartSlider, {
        cart: cart,
        title: getLabel('cart.title')
    }, children);
};

export { CartSliderContainer };
//# sourceMappingURL=CartSliderContainer.js.map
